import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/apiClient";
import { useFilter } from "@/context/FilterContext";
import { useSettings } from "@/hooks/useSettings";
import { RANGE_OPTIONS } from "@/lib/dateRange";

const SEL = "bg-navy border border-surface-hover rounded-md px-2.5 py-1.5 text-sm text-white focus:border-gold outline-none";

export default function FilterBar() {
  const { range, setRange, role, setRole, employee, setEmployee } = useFilter();
  const { data: settings } = useSettings();
  const { data: team = [] } = useQuery({ queryKey: ["team"], queryFn: async () => (await api.get("/team")).data });
  const roles = settings?.roles || [];
  const employees = (role ? team.filter((t) => t.role === role) : team).filter((t) => t.status !== "Inactive");

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="filter-bar">
      <select data-testid="filter-role" value={role} onChange={(e) => { setRole(e.target.value); setEmployee(""); }} className={SEL}>
        <option value="">All roles</option>
        {roles.map((r) => <option key={r} value={r}>{r}</option>)}
      </select>
      <select data-testid="filter-employee" value={employee} onChange={(e) => setEmployee(e.target.value)} className={SEL}>
        <option value="">All employees</option>
        {employees.map((t) => <option key={t.id} value={t.name}>{t.name}</option>)}
      </select>
      <select data-testid="date-range-select" value={range.key} onChange={(e) => setRange({ ...range, key: e.target.value })} className={SEL}>
        {RANGE_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      {range.key === "custom" && (
        <div className="flex items-center gap-1.5">
          <input data-testid="range-start" type="date" value={range.start || ""} onChange={(e) => setRange({ ...range, start: e.target.value })} className={SEL} />
          <span className="text-slatetext text-xs">to</span>
          <input data-testid="range-end" type="date" value={range.end || ""} onChange={(e) => setRange({ ...range, end: e.target.value })} className={SEL} />
        </div>
      )}
    </div>
  );
}
